/**
 *
 * @module entry
 * @desc {SDK.Services.Identity.Adobe} entry point.
 *
 */

import AdobeIdentityClient from './adobeIdentityClient';
import AdobeIdentityClientConfiguration from './adobeIdentityClientConfiguration';
import AdobeIdentityClientEndpoint from './adobeIdentityClientEndpoint';
import AdobeRegistration from './adobeRegistration';
import GetIdentityTokenResult from './getIdentityTokenResult';

/**
 *
 * @typedef SDK.Services.Identity.Adobe
 * @type {Object}
 *
 * @property {AdobeIdentityClient} AdobeIdentityClient
 * @property {AdobeIdentityClientConfiguration} AdobeIdentityClientConfiguration
 * @property {AdobeIdentityClientEndpoint} AdobeIdentityClientEndpoint
 * @property {AdobeRegistration} AdobeRegistration
 * @property {GetIdentityTokenResult} GetIdentityTokenResult
 *
 */

/**
 *
 * @type {SDK.Services.Identity.Adobe}
 *
 */
export default {

    AdobeIdentityClient,
    AdobeIdentityClientConfiguration,
    AdobeIdentityClientEndpoint,
    AdobeRegistration,
    GetIdentityTokenResult

};



// WEBPACK FOOTER //
// ./src/services/identity/adobe/entry.js